import { AgendaItemSubCategory } from '../calls.service'

export const PROCEDURAL_ITEM_EXAMPLES: Partial<Record<AgendaItemSubCategory, string[]>> = {
  [AgendaItemSubCategory.CHAIR_OF_THE_MEETING]: [
    'It was agreed that {{name}} be appointed Chair of the meeting.',
    '[No relevant discussion was found for Chair of the meeting.]',
  ],
  [AgendaItemSubCategory.NOTICE_GIVEN_TO_DIRECTORS]: [
    'It was noted that due notice of the meeting had been given to all directors.',
    'It was determined that proper notice had not been given to all directors.',
    '[No relevant discussion was found for notice.]',
  ],
  [AgendaItemSubCategory.QUORUM]: [
    'It was noted that a quorum was present.',
    'It was determined that a quorum was not present.',
    '[No relevant discussion was found for quorum.]',
  ],
  [AgendaItemSubCategory.APOLOGIES_FOR_ABSENCE]: [
    'No apologies for absence had been received.',
    'Apologies had been received from {{name(s)}}.',
    'No relevant discussion was found.',
  ],
  [AgendaItemSubCategory.DECLARATIONS_OF_INTERESTS]: [
    'No conflicts of interest were declared over and above those already on record and none were raised in respect of the business covered on the agenda.',
    'Conflicts of interest were declared by {{name(s)}}.',
    '[No relevant discussion was found for declarations of interest.]',
  ],
  [AgendaItemSubCategory.APPROVAL_OF_PREVIOUS_BOARD_MINUTES]: [
    'The minutes from the Board meeting held on {{date}} were approved as a correct record.',
    'The Board requested certain amendments to the previous minutes before approval: {{requested amendments}}',
    '[No relevant discussion was found for approval of previous minutes.]',
  ],
  [AgendaItemSubCategory.ANY_OTHER_BUSINESS]: [
    'There was no other business.',
    '[No relevant discussion was found around any other business.]',
    'Additional items were raised for discussion under AOB. {{Additional items}}',
  ],
  [AgendaItemSubCategory.DATE_OF_NEXT_MEETING]: [
    'It was noted that the next meeting would be held on {{date}} at {{time}}.',
    '[No relevant discussion was found around the date of next meeting.]',
  ],
  [AgendaItemSubCategory.CLOSE_OF_MEETING]: [
    'The meeting was declared closed.',
    'The meeting was adjourned without formal closure due to time constraints.',
    'The meeting was extended to address outstanding issues.',
    '[No relevant discussion was found around the closure of the meeting.]',
  ],
}
